import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserRoleType } from 'src/app/core/auth/models/user-role-types.enum';
import { FEATURE_KEY } from './constants';
import { UserState } from './state';

const selectUserState = createFeatureSelector<UserState>(FEATURE_KEY);

export const getUserState$ = createSelector(
    selectUserState,
    (state: UserState): UserState => state
);

export const isUserStaffAdmin$ = createSelector(
    selectUserState,
    (state: UserState): boolean => state.role >= UserRoleType.STAFF_ADMIN
);
